const dashboard = {
  DASHBOARD: 'DASHBOARD',
};
export { dashboard };
